import { Either, right } from 'fp-ts/lib/Either'

import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { CurrentUser } from '@/services/api/current-user'

/**
 * TODO: リリースを優先し、PRでの議論をいったん保留にしマージしている
 *
 * インタラクションではなく現在のユーザーのクラスとして実装し、
 * オブジェクト自身に有料会員であるかを判定するメソッドをもたせたほうが良いか
 * @see https://github.com/my-color/front/pull/6253#discussion_r835813826
 */
export class PaidMembershipInteraction {
  private readonly behavior: BehaviorConfig

  constructor(
    readonly brandEnglishName: string,
    private readonly currentUserService: CurrentUser = new CurrentUser()
  ) {
    this.behavior = BehaviorConfig.createFromBrand(this.brandEnglishName)
  }

  async isPaidMember(): Promise<Either<Error, boolean>> {
    // 有料会員機能がOFFの場合は、current_userを呼ばずにfalseを返す
    if (!this.behavior.paidMembership.enabled) {
      return right(false)
    }

    const result = await this.currentUserService.getCurrentUser()

    return result.map(u => u.membership.enabled && u.membership.registered_plans.length > 0)
  }
}
